import React, { useEffect, useRef, useState } from "react";
import SpinnerLoader from "../page/private/PolotnoDesign/SpinnerLoader";
import { trackAnalyticsEvent } from "../utils/analytics";

export default function LocalFontsComponants({
  onSelect,
  selected,
  onHover,
  selectedObject,
  searchQuery, // Receive search query from parent
  store,
  onMouseEnter,
  onMouseLeave,
  setSelectedFont,
  setOriginalFont,
  setIsFirstHover,
}) {
  const [loading, setLoading] = useState(false);
  const [localFonts, setLocalFonts] = useState([]);
  const [filteredLocalFonts, setFilteredLocalFonts] = useState([]);
  const [apiSupported, setApiSupported] = useState(false);
  const [showApiSupported, setShowApiSupported] = useState(false);
  const activeListItemRef = useRef(null);
  const element = store.selectedElements[0];
  const [selectedIndex1, setSelectedIndex1] = useState(null);
  const fontListRef = useRef([]);

  async function getLocalFonts() {
    if ("queryLocalFonts" in window) {
      setApiSupported(true);
      setLoading(true);
    } else {
      setApiSupported(false);
      return;
    }
    try {
      const fonts = await window.queryLocalFonts();
      setLocalFonts(fonts);
      setFilteredLocalFonts(fonts); // Initially set all fonts
    } catch (error) {
      console.error("Error fetching local fonts:", error);
    } finally {
      setLoading(false);
    }
  }

  const changeFontByIndex = (index, enter) => {
    console.log("indexxxx", index);
    const sFont = filteredLocalFonts[index];
    if (sFont) {
      element?.set({ fontFamily: sFont.fullName });
      fontListRef.current[index]?.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
      if (enter) {
        setSelectedFont(sFont.fullName);
      }
    }
  };

  useEffect(() => {
    const handleArrowNavigation = (e) => {
      if (loading || filteredLocalFonts.length === 0) return;
      let defaultIndex = filteredLocalFonts.findIndex(
        (font) => font.fullName === store.selectedElements[0]?.fontFamily
      );
      let indexinside;
      if (e.key === "ArrowDown") {
        e.preventDefault();
        setSelectedIndex1((prev) => {
          const nextIndex = Math.min(
            filteredLocalFonts.length - 1,
            (prev ? prev : defaultIndex) + 1
          );
          changeFontByIndex(nextIndex);
          indexinside = nextIndex;
          return nextIndex;
        });
      }

      if (e.key === "ArrowUp") {
        e.preventDefault();
        setSelectedIndex1((prev) => {
          const nextIndex = Math.max(0, (prev ? prev : defaultIndex) - 1);
          changeFontByIndex(nextIndex);
          indexinside = nextIndex;
          return nextIndex;
        });
      }
      console.log("selectedIndex1", selectedIndex1);
      // if (e.key === "Enter") {
      //   e.preventDefault();
      //   changeFontByIndex(indexinside, "enter"); // ✅ Call your function with the active index
      // }
    };

    document.addEventListener("keydown", handleArrowNavigation);
    return () => document.removeEventListener("keydown", handleArrowNavigation);
  }, [filteredLocalFonts, loading]);

  useEffect(() => {
    if ("queryLocalFonts" in window) {
      setApiSupported(true);
      getLocalFonts();
    } else {
      setShowApiSupported(true);
      setApiSupported(false);
    }
  }, []);

  function isGoogleChrome() {
    const ua = navigator.userAgent;

    const isChromium = window.chrome !== undefined;
    const isGoogleVendor = navigator.vendor === "Google Inc.";
    const isOpera = ua.includes("OPR");
    const isEdge = ua.includes("Edg");
    const isBrave = navigator.brave !== undefined;

    return ((isChromium && isGoogleVendor) || isEdge) && !isOpera && !isBrave;
  }

  useEffect(() => {
    if (searchQuery) {
      const filtered = localFonts.filter((font) =>
        font.fullName.toLowerCase().includes(searchQuery.toLowerCase())
      );
      setFilteredLocalFonts(filtered);
    } else {
      setFilteredLocalFonts(localFonts);
    }
  }, [searchQuery, localFonts]); // Run filter when `searchQuery` or `localFonts` change

  const handleFontClick = (fontName) => {
    // Apply the font permanently when clicked
    element?.set({ fontFamily: fontName });
    setSelectedFont(fontName);
    setOriginalFont(fontName); // Update the original font to the newly selected font
    setIsFirstHover(false); // Set first hover to false when user clicks
    trackAnalyticsEvent("design_font_selected", {
      font_name: fontName,
      font_source: "system",
    });
    element?.canvas?.requestRenderAll();
  };

  const handleMouseEnter = (fontName) => {
    // Set first hover to false on first interaction
    setIsFirstHover(false);
    onMouseEnter(fontName);
  };

  if (!apiSupported && showApiSupported) {
    return <h1>Your browser does not support the Font Access API</h1>;
  }

  if (loading) {
    return <SpinnerLoader loading={loading} />;
  }

  // console.log('navigator.userAgent',navigator.userAgent)
  return (
    <>
      <div className="font_pos">
        <ul className="options option_font">
          {isGoogleChrome() ? (
            filteredLocalFonts.length > 0 ? (
              filteredLocalFonts.map((option, index) => (
                <li
                  // ref={
                  //   store.selectedElements[0]?.fontFamily === option.fullName
                  //     ? activeListItemRef
                  //     : null
                  // }
                  ref={(el) => (fontListRef.current[index] = el)}
                  className={
                    store.selectedElements[0]?.fontFamily === option.fullName
                      ? "selectedFont"
                      : "fontlisthover"
                  }
                  style={{ fontFamily: option.fullName, cursor: "pointer" }}
                  key={index}
                  onMouseEnter={() => handleMouseEnter(option.fullName)}
                  onMouseLeave={onMouseLeave}
                  onClick={() => handleFontClick(option.fullName)}
                >
                  {option.fullName}
                </li>
              ))
            ) : (
              <li>No matching fonts found</li>
            )
          ) : (
            <li>Your broswer doesn't support local fonts</li>
          )}
        </ul>
      </div>
    </>
  );
}
